export default __webpack_public_path__ + "static/media/75yrs.2a9678bb.png";